import { google, ics, office365, outlook, yahoo } from 'calendar-link';
import type { CalendarEvent } from 'calendar-link';
import { LinkTarget } from '@legalzoom/constants';

export const allCalendarTypes = [
  'google',
  'yahoo',
  'icalendar',
  'outlook',
  'outlook-live',
] as const;

export type CalendarType = (typeof allCalendarTypes)[number];

export type CalendarLink = {
  id: CalendarType;
  label: (typeof calendarTypes)[CalendarType]['label'];
  destination: string;
  linkTarget: LinkTarget;
  className: string;
};

const calendarTypes = {
  google: {
    id: 'google',
    label: 'Google Calendar',
    destination: google,
    linkTarget: LinkTarget.Blank,
    className: 'text-link-action cursor-pointer typography-content-4',
  },
  yahoo: {
    id: 'yahoo',
    label: 'Yahoo! Calendar',
    destination: yahoo,
    linkTarget: LinkTarget.Blank,
    className: 'text-link-action cursor-pointer typography-content-4',
  },
  icalendar: {
    id: 'icalendar',
    label: 'iCalendar',
    destination: ics,
    linkTarget: LinkTarget.Blank,
    className: 'text-link-action cursor-pointer typography-content-4',
  },
  outlook: {
    id: 'outlook',
    label: 'Outlook Calendar',
    destination: office365,
    linkTarget: LinkTarget.Blank,
    className: 'text-link-action cursor-pointer typography-content-4',
  },
  'outlook-live': {
    id: 'outlook-live',
    label: 'Outlook Live',
    destination: outlook,
    linkTarget: LinkTarget.Blank,
    className: 'text-link-action cursor-pointer typography-content-4',
  },
} as const;

function buildCalendarLink({
  event,
  calendar,
}: {
  event: CalendarEvent;
  calendar: CalendarType;
}) {
  return {
    ...calendarTypes[calendar],
    destination: calendarTypes[calendar].destination(event),
  };
}

function buildCalendarLinks({
  event,
  calendars,
}: {
  event: CalendarEvent;
  calendars: readonly CalendarType[];
}): CalendarLink[] {
  const calendarLinks = calendars.map((calendar) =>
    buildCalendarLink({ event, calendar }),
  );
  return calendarLinks;
}

export default buildCalendarLinks;
